// Google Analytics 4 Service
class AnalyticsService {
  constructor() {
    this.gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    this.isInitialized = false;
  }

  // Google Analytics'i başlat
  initialize() {
    if (!this.gaId || this.isInitialized) return;

    // Google Analytics script'ini dinamik olarak yükle
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`;
    document.head.appendChild(script);

    // gtag fonksiyonunu tanımla
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    // Google Analytics'i başlat
    gtag('js', new Date());
    gtag('config', this.gaId, {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: false, // Manuel olarak sayfa görüntülemelerini göndereceğiz
    });

    this.isInitialized = true;
  }

  // Sayfa görüntüleme olayını gönder
  trackPageView(pageTitle = null, pagePath = null) {
    if (!this.isInitialized) return;

    const title = pageTitle || document.title;
    const path = pagePath || window.location.pathname;

    window.gtag('config', this.gaId, {
      page_title: title,
      page_location: window.location.origin + path,
      page_path: path,
    });
  }

  // Özel olayları takip et
  trackEvent(eventName, parameters = {}) {
    if (!this.isInitialized) return;

    window.gtag('event', eventName, parameters);
  }

  // Kullanıcı arama olayını takip et
  trackSearch(searchTerm, resultsCount = 0) {
    this.trackEvent('search', {
      search_term: searchTerm,
      results_count: resultsCount,
    });
  }

  // Koç profili görüntüleme olayını takip et
  trackCoachView(coachName, coachId) {
    this.trackEvent('view_coach_profile', {
      coach_name: coachName,
      coach_id: coachId,
    });
  }

  // Kayıt olma olayını takip et
  trackSignUp(method = 'email') {
    this.trackEvent('sign_up', {
      method: method,
    });
  }

  // Giriş yapma olayını takip et
  trackSignIn(method = 'email') {
    this.trackEvent('login', {
      method: method,
    });
  }

  // İletişim olayını takip et
  trackContact(coachName, contactMethod) {
    this.trackEvent('contact_coach', {
      coach_name: coachName,
      contact_method: contactMethod,
    });
  }

  // Kategori görüntüleme olayını takip et
  trackCategoryView(categoryName, categoryId) {
    this.trackEvent('view_category', {
      category_name: categoryName,
      category_id: categoryId,
    });
  }

  // Hata olayını takip et
  trackError(errorMessage, errorCode = null) {
    this.trackEvent('error', {
      error_message: errorMessage,
      error_code: errorCode,
    });
  }
}

// Singleton instance
const analyticsService = new AnalyticsService();

export default analyticsService;
